import {SelectData} from '@shared/modules/form/modules/select/interfaces/select-data.interface';
import {Roles, RolesIds, RolesNames} from '@core/modules/role/enums/roles.enum';

export const RolesAll: Roles[] = [
  Roles.Admin,
  Roles.Auditor,
  Roles.AuditorVerifier,
  Roles.Verifier,
  Roles.Agent
];

export const AvailableSelectRoles: SelectData[] = [
  {
    value: RolesIds.Agent,
    label: RolesNames.Agent
  },
  {
    value: RolesIds.Auditor,
    label: RolesNames.Auditor
  },
  {
    value: RolesIds.AuditorVerifier,
    label: RolesNames.AuditorVerifier,
  },
  {
    value: RolesIds.Verifier,
    label: RolesNames.Verifier,
  },
];
